import { isEmpty } from 'lodash-es';

import { useSecurityAuditLevelSecretsList } from '../../hooks/useSecurityAuditLevelSecretsList';
import { SecretsListContainer } from '../SecretsListContainer';
import { SecurityAuditLevelSecretsList } from '../SecurityAuditLevelSecretsList';
import { SecurityAuditListEmpty } from '../SecurityAuditListEmpty';

export const SecurityAuditLevelSecrets = () => {
    const data = useSecurityAuditLevelSecretsList();

    return (
        <SecretsListContainer isEmpty={isEmpty(data)} empty={<SecurityAuditListEmpty messageId='securityAudit.list.empty' />}>
            {({ height, width }) => <SecurityAuditLevelSecretsList data={data} height={height ?? 600} width={width ?? 800} />}
        </SecretsListContainer>
    );
};
